import styledComponents from "styled-components";

const Title = styledComponents.h2`
  margin: 1rem 0;
  font-size:2rem;
  display:block;
`;

export default Title;
